import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { List, Select, ListApi, loopback, Filter } from "elentari";
import { treinoApi, treinoObjetivoApi } from "../../services/Api";
import { useTreinoObjetivos, capitalizeFirstLetter } from "./treinoHooks";

const { loopbackFilters } = loopback;

const TreinoFilter = () => {
  const [treinoTipo, setTreinoTipo] = useState([]);
  const treinoObjetivos = useTreinoObjetivos();

  const fetchTreinosTipo = async () => {
    const response = await treinoApi.getList();
    if (response.ok) {
      setTreinoTipo(
        Array.from(new Set(response.data.map((item) => item.tipo)))
      );
    }
  };
  useEffect(() => {
    fetchTreinosTipo();
  }, []);
  return (
    <Filter labels={{ find: "Buscar", clear: "Limpar" }}>
      <Grid spacing={24} container>
        <Grid item xs>
          <Field fullWidth label="Nome" component={TextField} name="nome" />
        </Grid>
        <Grid item xs>
          <Field
            fullWidth
            component={Select}
            options={treinoTipo.map((item) => ({
              label: capitalizeFirstLetter(item),
              value: item,
            }))}
            label="Tipo"
            name="tipo"
          />
        </Grid>
        <Grid item xs>
          <Field
            fullWidth
            component={Select}
            options={treinoObjetivos}
            label="Objetivo"
            name="treinoObjetivoId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
};

export function TreinoList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      id: {
        label: "Id",
      },
      nome: {
        label: "Nome",
      },
      tipo: {
        label: "Tipo",
      },
      treinoObjetivoId: {
        label: "Objetivo",
        getOne: treinoObjetivoApi.getOne,
        key: "nome",
      },
    },
  };

  return (
    <ListApi
      filtersConfig={{
        nome: loopbackFilters.regexp,
        tipo: loopbackFilters.regexp,
      }}
      api={treinoApi}
    >
      {({ getPage, getCount, handleDelete }) => (
        <div>
          <TreinoFilter />
          <List
            {...props}
            withPaper
            deleteItem={handleDelete}
            onClickEdit={(item) => props.history.push(`/treinos/${item.id}`)}
            onClickNew={() => props.history.push("/treinos/new")}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}
